export const appSettings = {
  citationURL: '',
  resetPasswordURL: '',
  generateIndustryReportButtonEnabled: false,
  testMode: true
};
